
import dateFormat from 'vux/src/tools/date/format.js'

import {
apiUrl,
apiParams
} from '@/const/const'
import MyBtnReturn from '@/components/subComponents/MyBtnReturn'

export default {
name: 'DeliveImgList',
components: {
MyBtnReturn
},
data() {
return {
src1: require('@/assets/images/plan/wx_zhuang_blue.png'), // 装箱的icon图片
src2: require('@/assets/images/wx_song_green.png'), // 送货的icon图片
tableData: [],
isShowTable: true,
isShowLoading: false,
isNoData: false,
}
},
created() {
document.title = '位置上传';
this.getData()
},
methods: {
getData() {
let data = {
openId: apiParams.openId,
companyId: apiParams.companyId,
code: apiParams.code,
};
this.isShowLoading = true;
this.requestApi({
url: apiUrl.locationNoticeList,
data: data
}, (resultData) => {
let list = resultData.data.list || [];
if (list.length === 0) {
this.isNoData = true;
this.isShowLoading = false;
this.isShowTable = false;
return
}
this.tableData = list;
}, (error) => {
this.isShowLoading = false;
if (error) {
console.error(error);
}
})
},
goNextPage(bookingId, ladingId, servicetype) {

this.$router.push({
name: 'LocationUpload',
query: {
bookingId: bookingId,
ladingId: ladingId,
servicetype: servicetype,
}
})
},
dateFormat(time) {
return dateFormat(time, 'YYYY-MM-DD HH:mm')
}
}
}



// WEBPACK FOOTER //
// ./src/components/siji/locationUpdate/LocationUploadList.vue